import * as React from "react";
import styled, { css } from "styled-components";

const ColorValueDependendentBox = styled.div<IValue>`
  flex: 0.5;
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: ${({ theme }) => theme.space[2]};
  height: 100%;
  padding: ${({ theme }) => theme.space[3]} ${({ theme }) => theme.space[2]};
  box-shadow: inset 0 0 0 2px ${({ theme }) => theme.colors.yellow};
  border-radius: ${({ theme }) => theme.radii[2]};

  @media (min-width: ${(props) => props.theme.breakpoints[1]}) {
    flex: 1;
  }

  ${(props) =>
    props.isError &&
    css`
      background-color: ${props.theme.colors.error};
      color: ${props.theme.colors.white};
      box-shadow: none;
    `}

  ${(props) =>
    props.isSuccess &&
    css`
      background-color: ${props.theme.colors.success};
      box-shadow: none;
    `}
`;

const Heading = styled.h3`
  flex: 1;
  margin: 0;
  font-family: ${(props) => props.theme.fonts.body};
  font-size: ${(props) => props.theme.fontSizes[1]};
  font-weight: normal;
  line-height: 1;
`;

const Value = styled.div<IValue>`
  font-family: ${(props) => props.theme.fonts.body};
  font-size: ${(props) => props.theme.fontSizes[1]};
  font-weight: 500;
  text-align: end;
  line-height: 1;
`;

interface IScoreboardPanel {
  heading: string;
  value: string;
}

interface IValue {
  isError?: boolean;
  isSuccess?: boolean;
}

type Props = IScoreboardPanel & IValue;

export const ScoreboardPanel: React.FC<Props> = ({
  heading,
  isError,
  isSuccess,
  value,
}) => (
  <ColorValueDependendentBox isError={isError} isSuccess={isSuccess}>
    <Heading>{heading}</Heading>
    <Value>{value}</Value>
  </ColorValueDependendentBox>
);

export default ScoreboardPanel;
